<template>
  <v-card>
    <v-card-title primary-title>
      Ta bort email mall: {{ mailTemplates[uuid].name }}
    </v-card-title>

    <v-card-text>
      Är du säker på att du vill ta bort email mallen?
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="onClose">
        Avbryt
      </v-btn>
      <v-btn type="submit" color="error" text @click="onConfirm">
        Ta bort
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import DELETE_MAIL_TEMPLATE from '@/gql/mailTemplates/mutations/DeleteMailTemplate.gql'
import { get } from 'vuex-pathify'

export default {
  name: 'MasterdataEmailTemplatesDelete',

  props: {
    uuid: String,
  },

  computed: {
    mailTemplates: get('mailTemplates/data'),
  },

  methods: {
    async onConfirm() {
      this.deleteMailTemplate()
      this.onClose()
    },

    onClose() {
      this.$emit('close')
    },

    deleteMailTemplate() {
      return this.$apollo.mutate({
        mutation: DELETE_MAIL_TEMPLATE,
        variables: {
          uuid: this.uuid,
        },

        update: () => {
          const updatedMailTemplates = Object.values(this.mailTemplates)
            .filter(x => x.uuid !== this.uuid)
            .reduce((a, b) => {
              a[b.uuid] = b
              return a
            }, {})
          this.$store.set('mailTemplates/data', updatedMailTemplates)
        },
      })
    },
  },
}
</script>
